import { REDUX_ACTIONS, GAME_ID } from 'a/pickyGoblins/data/constants';

const initialState = {
  cardsDraggable: false,
  wordToHighlight: '',
  wordToShake: '',
  answerOrder: [],
};

const practiceReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case REDUX_ACTIONS.PRACTICE_UPDATE_CARDS_DRAGGABLE:
      return {
        ...state,
        cardsDraggable: payload,
      };

    case REDUX_ACTIONS.PRACTICE_UPDATE_WORD_TO_HIGHLIGHT:
      return {
        ...state,
        wordToHighlight: payload,
      };

    case REDUX_ACTIONS.PRACTICE_UPDATE_WORD_TO_SHAKE:
      return {
        ...state,
        wordToShake: payload,
      };

    case REDUX_ACTIONS.PRACTICE_ADD_ANSWER: {
      const { answerOrder } = state;
      answerOrder.push(payload);
      return {
        ...state,
        answerOrder,
      };
    }
    case REDUX_ACTIONS.PRACTICE_RESET:
      return {
        cardsDraggable: false,
        wordToHighlight: '',
        answerOrder: [],
      };

    default:
      return state;
  }
};

export default practiceReducer;
